import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

/**
 * options provides a single source of truth for the keys required to access
 * school options.
 */
export default BaseEnum.create({
  values: [
    // Assessment Options
    {
      value: 'parents:assessment:showOverviewOnPages',
      label: 'ASSESSMENTS_SHOW_OVERVIEW',
    },
    {
      value: 'parents:assessment:showOverviewOnHomepage',
      label: 'ASSESSMENTS_SHOW_HOMEPAGE_OVERVIEW',
    },

    // Attendance Options
    {
      value: 'core:attendance:periodsLabel',
      label: 'ATTENDANCE_PERIODS_LABEL',
    },
    {
      value: 'parents:attendance:showAttendanceDial',
      label: 'ATTENDANCE_SHOW_TO_CAREGIVERS',
    },

    // Content Options
    {
      value: 'parents:content:communityFeedComments',
      label: 'COMMUNITY_FEED_COMMENTS',
    },
    { value: 'parents:content:isViewable', label: 'CONTENT_IS_VIEWABLE' },
    {
      value: 'parents:content:expectedAccessDate',
      label: 'CONTENT_VIEWABLE_DATE',
    },

    // Expectation Options
    {
      value: 'parents:expectations:progressCharts',
      label: 'EXPECTATIONS_PROGRESS_CHARTS',
    },
    {
      value: 'parents:expectations:showProgressChartKey',
      label: 'EXPECTATIONS_PROGRESS_CHART_KEY',
    },
    {
      value: 'parents:expectations:showAchievementStatements',
      label: 'EXPECTATIONS_SHOW_ACHIEVEMENT_STATEMENTS',
    },
    {
      value: 'parents:expectations:showCurrentExpectation',
      label: 'EXPECTATIONS_SHOW_CURRENT_EXPECTATION',
    },
    {
      value: 'parents:expectations:includeMilestone',
      label: 'EXPECTATIONS_INCLUDE_MILESTONE',
    },
    {
      value: 'parents:expectations:includeCurriculumLevel',
      label: 'EXPECTATIONS_INCLUDE_CURRICULUM_LEVEL',
    },
    {
      value: 'parents:expectations:showAchievementChips',
      label: 'EXPECTATIONS_SHOW_ACHIEVEMENT_CHIPS',
    },

    // Goal Options
    { value: 'parents:goals:visible', label: 'GOALS_VISIBLE' },
    { value: 'parents:goals:showGoalProgress', label: 'GOALS_SHOW_PROGRESS' },
    { value: 'parents:goals:showSecure', label: 'GOALS_SHOW_SECURE' },
    { value: 'parents:goals:numRecentGoals', label: 'GOALS_NUM_SECURE' },
    { value: 'parents:goals:showCurrent', label: 'GOALS_SHOW_CURRENT' },
    { value: 'parents:goals:numCurrentGoals', label: 'GOALS_NUM_CURRENT' },

    // Progress/Reporting Options
    {
      value: 'progress:reporting:enabled',
      label: 'PROGRESS_REPORTING_ENABLED',
    },
    {
      value: 'progress:reporting:showAchievementStatements',
      label: 'EXPECTATIONS_SHOW_ACHIEVEMENT_STATEMENTS_STAFF',
    },
    {
      value: 'progress:reporting:showCurrentExpectation',
      label: 'EXPECTATIONS_SHOW_CURRENT_EXPECTATION_STAFF',
    },
    {
      value: 'progress:reporting:includeMilestone',
      label: 'EXPECTATIONS_INCLUDE_MILESTONE_STAFF',
    },
    {
      value: 'progress:reporting:includeCurriculumLevel',
      label: 'EXPECTATIONS_INCLUDE_CURRICULUM_LEVEL_STAFF',
    },
    {
      value: 'progress:reporting:showAchievementChips',
      label: 'EXPECTATIONS_SHOW_ACHIEVEMENT_CHIPS_STAFF',
    },
    { value: 'progress:reporting:style', label: 'REPORTING_STYLE' },
    {
      value: 'progress:charts:showAllColours',
      label: 'CHARTS_SHOW_ALL_COLOURS',
    },
    {
      value: 'progress:charts:showYAxisLabels',
      label: 'CHARTS_SHOW_Y_AXIS_LABELS',
    },
    {
      value: 'progress:charts:hideTooltip',
      label: 'CHARTS_HIDE_TOOL_TIP',
    },
    {
      value: 'parents:reportPage:pageName',
      label: 'REPORTING_REPORT_PAGE_NAME',
    },
    {
      value: 'parents:reportPage:reportDescription',
      label: 'REPORTING_REPORT_DESCRIPTION',
    },
    {
      value: 'parents:reportPage:reportMedia',
      label: 'REPORTING_REPORT_MEDIA',
    },
    {
      value: 'parents:reportPage:mainBlocks',
      label: 'REPORTING_REPORT_MAIN_BLOCKS',
    },
    {
      value: 'parents:reportPage:pageBlocks',
      label: 'REPORTING_REPORT_PAGE_BLOCKS',
    },
    {
      value: 'parents:reportPage:postsPerPage',
      label: 'REPORTING_REPORT_POSTS_PER_PAGE',
    },
    {
      value: 'parents:reportPage:showSubjectsOn',
      label: 'REPORTING_SHOW_SUBJECTS_ON',
    },
    {
      value: 'parents:reportPage:showAchievementKey',
      label: 'REPORTING_SHOW_ACHIEVEMENT_KEY',
    },
    {
      value: 'parents:reportPage:mini-cards',
      label: 'REPORTING_MINI_GRADED_CARDS',
    },

    // Sponsored Content
    {
      value: 'parents:sponsoredContent:enabled',
      label: 'SPONSORED_CONTENT_ENABLED',
    },
    {
      value: 'parents:sponsoredContent:image',
      label: 'SPONSORED_CONTENT_IMAGE',
    },
    { value: 'parents:sponsoredContent:link', label: 'SPONSORED_CONTENT_LINK' },

    // School App Settings
    { value: 'app:links:school_website', label: 'APP_LINKS_SCHOOL_WEBSITE' },
    { value: 'app:links:policies', label: 'APP_LINKS_POLICIES' },
    { value: 'app:links:hail', label: 'APP_LINKS_HAIL' },
    { value: 'app:links:facebook', label: 'APP_LINKS_FACEBOOK' },
    { value: 'app:links:twitter', label: 'APP_LINKS_TWITTER' },
    { value: 'app:links:instagram', label: 'APP_LINKS_INSTAGRAM' },
    { value: 'app:links:shop', label: 'APP_LINKS_SHOP' },
    { value: 'app:links:food', label: 'APP_LINKS_FOOD' },
    { value: 'app:links:uniform', label: 'APP_LINKS_UNIFORM' },
    { value: 'app:links:news', label: 'APP_LINKS_NEWS' },
    { value: 'app:links:portal', label: 'APP_LINKS_PORTAL' },
    { value: 'app:links:library', label: 'APP_LINKS_LIBRARY' },
    {
      value: 'app:links:googleCalendar',
      label: 'APP_LINKS_GOOGLE_CALENDAR',
    },
    { value: 'app:features:school_logo', label: 'APP_SHOW_LOGO' },
    { value: 'app:features:logo_size', label: 'APP_LOGO_SIZE' },
    { value: 'app:features:theme', label: 'APP_THEME' },
    {
      value: 'app:features:absence_reporting',
      label: 'APP_FEATURE_ABSENCE_REPORTING',
    },

    // Rollover Date
    { value: 'hero:rollover:month', label: 'HERO_ROLLOVER_MONTH' },
    { value: 'hero:rollover:date', label: 'HERO_ROLLOVER_DATE' },

    // Post Templates
    {
      value: 'hero:features:postTemplatesEnabled',
      label: 'HERO_POST_TEMPLATES_ENABLED',
    },

    // Warehouse Stationery
    {
      value: 'hero:features:warehouseStationeryJson',
      label: 'HERO_WAREHOUSE_STATIONERY_JSON',
    },
    // Notifications
    {
      value: 'notifications:app:enable',
      label: 'NOTIFICATIONS_APP_ENABLED',
    },
    {
      value: 'notifications:app:posts',
      label: 'NOTIFICATIONS_APP_POSTS',
    },
    {
      value: 'notifications:app:noticesCommunity',
      label: 'NOTIFICATIONS_APP_COMMUNITY_NOTICES',
    },
    {
      value: 'notifications:app:noticesStudent',
      label: 'NOTIFICATIONS_APP_STUDENT_NOTICES',
    },
    {
      value: 'notifications:email:enable',
      label: 'NOTIFICATIONS_EMAIL_ENABLED',
    },
    {
      value: 'notifications:email:posts',
      label: 'NOTIFICATIONS_EMAIL_POSTS',
    },
    {
      value: 'notifications:email:noticesCommunity',
      label: 'NOTIFICATIONS_EMAIL_COMMUNITY_NOTICES',
    },
    {
      value: 'notifications:email:noticesStudent',
      label: 'NOTIFICATIONS_EMAIL_STUDENT_NOTICES',
    },

    // Sidekick support.
    {
      value: 'hero:features:sidekick',
      label: 'SIDEKICK_ENABLED',
    },

    // Calendar & Excursions
    {
      value: 'hero:features:events',
      label: 'EVENTS_ENABLED',
    },

    // Advanced Goals functionality.
    {
      value: 'hero:features:gradable:goal:sets',
      label: 'GOALS_GRADING_ENABLED',
    },
    {
      value: 'hero:features:linkedgoals',
      label: 'LINKED_GOALS_ENABLED',
    },
    {
      value: 'hero:features:control-panel',
      label: 'CONTROL_PANEL_ENABLED',
    },

    // Snapshots/Report Snapshots - only controls access to the UI
    {
      value: 'hero:features:reportSnapshots',
      label: 'REPORT_SNAPSHOTS_ENABLED',
    },

    {
      value: 'hero:features:teRitoEnabled',
      label: 'TE_RITO_ENABLED',
    },

    // Finance - NSW DoE Options
    {
      value: 'hero:nswDOE:prohibitedFinancialLanguage',
      label: 'NSW_DOE_PROHIBITED_FINANCIAL_LANGUAGE',
    },
  ],
});
